
import { Component, Vue } from "vue-property-decorator";
import { namespace, State } from "vuex-class";
import { get } from "lodash";
import { FeaturesList, RootState } from "@/store/types";
import { LinkedCamera } from "@/store/manual-actions/types";

// Components
import { EventsQueueState } from '@/store/eventqueue/types';
import ManualAction from './ManualAction.vue';

// Vuex modules
const Eventqueue = namespace("eventqueue");

@Component({
	components: {
		"manual-action": ManualAction,
	}
})
export default class ManualActionModal extends Vue {

	// -- Vuex -- //

	// Root
	@State((state: RootState) => state.featuresList) featureList!: FeaturesList;

	// EventQueue
	@Eventqueue.State((State: EventsQueueState) => State.ManualActionShown) manualActionShown!: boolean;
	@Eventqueue.Mutation setManualActionShown: (shown: boolean) => void;


	// -- Properties -- //

	public linkedCameras: LinkedCamera[] = [];


	// -- Computed properties -- //

	public get isQuickControlCamerasEnabled(): boolean {
		return get(this.featureList, ["Alarms", "QuickControl", "Cameras"]);
	}

	// -- Methods -- //

	/**
	 * @summary Resets the modal back to it's original state and hides it.
	 */
	public cancel(): void {
		this.setManualActionShown(false);
	}

}
